import React from 'react'
import { StyleObject } from 'styletron-react'
import { lightTheme } from '@/customTheme'

/** Base visual style for the 40×40 white circle with AI glow shadow.
 *  Spread into a StyleObject to use with interactive buttons. */
export const AI_GLOW_CIRCLE_STYLE: StyleObject & React.CSSProperties = {
  width: '40px',
  height: '40px',
  borderRadius: '360px',
  backgroundColor: lightTheme.colors.white,
  boxShadow: lightTheme.colors.aiGlowBoxShadow,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

interface AiGlowCircleProps {
  children?: React.ReactNode
  style?: React.CSSProperties
}

/** 40×40 white circle with the AI glow shadow. Use `style` for positioning / interaction overrides. */
const AiGlowCircle: React.FC<AiGlowCircleProps> = ({ children, style }) => (
  <div style={{ ...AI_GLOW_CIRCLE_STYLE, ...style }}>{children}</div>
)

export default AiGlowCircle
